import { render, staticRenderFns } from "./Hoarding.vue?vue&type=template&id=6655153b&scoped=true"
import script from "./Hoarding.vue?vue&type=script&lang=js"
export * from "./Hoarding.vue?vue&type=script&lang=js"
import style0 from "./Hoarding.vue?vue&type=style&index=0&id=6655153b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6655153b",
  null
  
)

export default component.exports